<template>
    <section class="login-section">
        <div class="thumb-container absolute" :style='"background-image: url(" + footer.bg4_url + ")"'></div>
        <div class="container">
            <slot></slot>
        </div>
    </section>
</template>

<script>
export default {
    computed: {
        footer() {
            return this.$store.getters.getFooter;
        }
    }
}
</script>

